import React from "react";
import styled from "styled-components";
import { Typography } from "@material-ui/core";
export const Li = styled.li`
    margin-bottom: 15px;
`;
export const ListItem = ({ text }) => {
    return (
        <Li>
            <Typography variant="title">{text}</Typography>
        </Li>
    );
};

export const StyledTable = styled.table`
    border: 1px solid black;
    margin-top: 15px;
    padding: 10px;
`;
